import React, { useEffect } from 'react';
import Profile from './Profile';
import { fetchProfileAction, saveProfileAction } from '../../../store/_auth/auth.actions';
import { connect } from 'react-redux';
import Loading from '../../../components/style-guide/loading/Loading';

export const ProfileProvider = ({ profile, actions}) => {

  useEffect(() => {
    actions.fetchProfileAction();
  }, []);

  return !profile ? <Loading /> : (<Profile onSubmit={actions.saveProfileAction} userInfo={profile}/>);
};

const mapStateToProps = (state) => ({
  profile: state.authReducers.profile,
});

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      saveProfileAction: (payload) => dispatch(saveProfileAction(payload)),
      fetchProfileAction: () => dispatch(fetchProfileAction()),
    },
    dispatch
  }
};

export default React.memo(connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileProvider));
